<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-3">
          <h6>Year</h6>
        </div>
        <div class="col-3">
          <h6>Price</h6>
        </div>
        <div class="col-3">
          <h6>Source</h6>
        </div>
      </div>
      <div class="row" v-for="dataPoint in taxHistory.slice(0,5)" v-bind:key="dataPoint.year">
        <div class="col-3">
          <p>{{ dataPoint.year }}</p>
        </div>
        <div class="col-3">
          <p>${{ dataPoint.tax.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</p>
        </div>
        <div class="col-3">
          <p>NorthstarMLS</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    taxHistory: Array
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/home/homeData/dropdowns/TaxHistory.vue